export default __webpack_public_path__ + "static/media/interface-24.dfc6bab0.svg";